import React, { useContext } from 'react';
import classnames from 'classnames';
import { Button } from 'react-bootstrap';
import { ControlProps, GroupBase, components } from 'react-select';
import { SelectOption } from '../MultiFilterDropdown';
import Checkbox from 'v2/common/CheckBox/Checkbox';
import styles from './ControlComponentAlternative.module.scss';
import { CurrentStateFilterContext } from 'v2/context/currentStateFilterContext';

function ControlComponent<T>(
  props: ControlProps<SelectOption<T>, true, GroupBase<SelectOption<T>>>
) {
  const { currentState, setCurrentState } = useContext(
    CurrentStateFilterContext
  );
  return (
    <div>
      <components.Control {...props} />
      <div className="ml-2 mr-3 mt-4 d-flex justify-content-between">
        <Checkbox
          key={`selectAll-${props.selectProps.id}`}
          keyText={`selectAll-${props.selectProps.id}`}
          checked={currentState.is_all}
          label={'Select All'}
          lineal={true}
          onChange={() => {
            setCurrentState((previous) => {
              return { ...previous, is_all: !previous.is_all };
            });
          }}
        />
        <div>
          <span>View</span>
          <Button
            className={classnames('d-inline-block p-0 pl-2', {
              [styles.buttonLink]: currentState.view_all,
              'font-weight-bold': currentState.view_all,
            })}
            variant="link"
            onClick={() => {
              setCurrentState((previous) => {
                return { ...previous, view_all: true };
              });
            }}
          >
            ALL
          </Button>
          <Button
            variant="link"
            className={classnames('d-inline-block p-0 pl-2', {
              [styles.buttonLink]: !currentState.view_all,
              'font-weight-bold': !currentState.view_all,
            })}
            onClick={() => {
              setCurrentState((previous) => {
                return { ...previous, view_all: false };
              });
            }}
          >
            SELECTED
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ControlComponent;
